import { csvDownload } from '@openx/components-core/utils/csvDownload.tsx';
import type { InventoryListByIdAPI } from '@openx/types/inventoryList.ts';

export const inventoryListHeaders: { key: keyof InventoryListByIdAPI; label: string }[] = [
  { key: 'id', label: 'Inventory List Id' },
  { key: 'name', label: 'Inventory List Name' },
  { key: 'description', label: 'Inventory List Description' },
  { key: 'created_date', label: 'Created' },
  { key: 'modified_date', label: 'Last Modified' },
  { key: 'type_full', label: 'List Type' },
  { key: 'values', label: 'Values' },
];

export const prepareDataForDownload = (inventoryList: InventoryListByIdAPI) => {
  const editableInventoryList = { ...inventoryList, description: inventoryList.description?.replace(/"/g, '""') || '' };

  const entries = Object.entries(editableInventoryList);
  const rowCount = entries.reduce(
    (max, [, value]) => (Array.isArray(value) && value.length > max ? value.length : max),
    1
  );

  return Array.from({ length: rowCount }, (_, rowIndex) =>
    Object.fromEntries(
      entries.map(([key, value]) =>
        Array.isArray(value) ? [key, value[rowIndex] ?? ''] : [key, rowIndex === 0 ? value : '']
      )
    )
  );
};

export const downloadInventoryList = (inventoryList: InventoryListByIdAPI) => {
  csvDownload({
    data: prepareDataForDownload(inventoryList),
    filename: `OpenXSelect Inventory List - ${inventoryList.id}`,
    headers: inventoryListHeaders,
  });
};
